<template>
  <div
    class="
      assertFollowingWordsPopupContainer
      flexContainer
      centerContainer
      columnContainer
    "
  >
    <p class="bigText">Spokojnie!</p>
    <p class="mediumText">
      Słowa, w których chcesz stworzyć link do Twojego artykułu, muszą
      występować kolejno po sobie w tekście.
    </p>
    <button class="linkAlike" style="font-size: 1em" @click="closePopup">
      Wspaniale!
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
  },
};
</script>

<style scoped>
.assertFollowingWordsPopupContainer {
  width: 25%;
  height: 25%;
  margin-top: 15%;
  margin-left: 26%;
  border: 2px solid #394247;
  background-color: #ffffff;
  padding: 0.5%;
  box-shadow: 0 0 0 4px #fff, 0 0 0 6px #586471, 0 0 0 8px #fff,
    0 0 0 9px #586471;
}

p {
  line-height: 25px;
  margin: 2%;
}

button {
  text-decoration: none;
  color: #ec783e;
}

button:hover {
  text-decoration: underline;
}

@media (max-width: 1000px) {
  .assertFollowingWordsPopupContainer {
    margin-top: 53%;
    margin-left: 6%;
    width: 75%;
    height: 40%;
  }
}
</style>
